import { ArrowLeftIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { DocumentViewer } from '@odo/shared-ui';
import api from '../../../../../api/config';

interface DxReportPreviewPaneProps {
    url: string;
    fileName: string;
    version: number;
    onClose: () => void;
}

/**
 * Read-only PDF viewer for a submitted Dx report. Embeds the shared
 * DocumentViewer with the configured backend baseURL and the local
 * bearer-token getter so signed previews load correctly.
 */
export function DxReportPreviewPane({ url, fileName, version, onClose }: DxReportPreviewPaneProps) {
    return (
        <div className="flex flex-col flex-1 min-h-0">
            <div className="flex items-center justify-between px-5 py-3 border-b border-gray-200 flex-shrink-0">
                <button
                    onClick={onClose}
                    className="flex items-center gap-1.5 text-gray-500 hover:text-gray-800 transition-colors text-sm"
                >
                    <ArrowLeftIcon className="w-3.5 h-3.5" />
                    Back to Dx reports
                </button>
                <div className="flex items-center gap-2 max-w-[50%]">
                    <span className="text-[10px] font-semibold text-gray-600 bg-gray-100 px-1.5 py-0.5 rounded flex-shrink-0">
                        v{version}
                    </span>
                    <div className="text-sm font-semibold text-gray-800 truncate">{fileName}</div>
                </div>
                <button
                    onClick={onClose}
                    className="flex items-center justify-center w-8 h-8 rounded-lg hover:bg-gray-100 transition-colors"
                >
                    <XMarkIcon className="w-4 h-4 text-gray-500" />
                </button>
            </div>
            <div className="flex-1 min-h-0 p-5">
                <DocumentViewer
                    documents={url}
                    apiBaseUrl={api.defaults.baseURL ?? ''}
                    showControls
                    className="h-full"
                    getAuthToken={() => localStorage.getItem('odo_login_token')}
                />
            </div>
        </div>
    );
}
